<template>
  <div
    class="container"
    :style="!productlist || !productlist.length ? { background: '#ffffff' } : {}"
  >
    <div
      class="pay_info"
      v-if="payResult == 'success' && integralType == '-1'"
      style="height: auto"
    >
      <div class="money" v-if="parseFloat(money)">
        <span>¥</span>
        {{ parseFloat(money).toFixed(2) }}
      </div>
      <div class="paystatetxt">支付成功</div>
      <div class="paystatetxt yellow" v-if="getintegral > 0 && ztpay != 1">
        确认收货后可获得{{ getintegral }}金币
      </div>
      <div class="paystatetxt yellow" v-else-if="ztpay == 1">请前往创客APP查看订单</div>
      <div class="btnlist" v-if="ztpay != 1">
        <div @click="other(1)" class="btn" v-if="anncc == 1">查看账单</div>
        <div @click="other(0)" class="btn" v-else>看看其它</div>
        <div @click="orderDetails" class="btn redbtn leftsp">查看订单</div>
      </div>
    </div>
    <div
      class="pay_info"
      v-else-if="payResult == 'success' && integralType != '-1'"
      style="height: auto"
    >
      <div class="paystatetxt bold">支付成功</div>
      <div class="only" v-if="integralType == 0">
        <span class="integral">{{ integralcount }}</span>
        <span class="label">金币</span>
      </div>
      <div class="all" v-if="integralType == 1">
        <div class="money" v-if="parseFloat(money)">
          <span>¥</span>
          {{ parseFloat(money).toFixed(2) }}
        </div>
        <div class="more">
          <div class="label">消耗金币:</div>
          <div class="integral">{{ integralcount }}</div>
        </div>
      </div>
      <div class="btnlist">
        <div @click="other" class="btn">看看其它</div>
        <div @click="orderDetails" class="btn redbtn leftsp">查看订单</div>
      </div>
    </div>
    <div class="pay_fail_info" v-if="payResult == 'failure'" style="height: auto">
      <div class="paystatetxt">付款失败</div>
      <div class="paydesc" v-if="ztpay != 1">
        请在
        <span>
          <van-count-down
            @finish="closeOrder"
            :time="time"
            :format="format"
            style="display: inline-block"
          />
        </span>
        内完成付款
        <br />
        否则订单会被系统取消
      </div>
      <div class="paydesc" v-else>请前往创客APP查看订单</div>
      <div class="btnlist" v-if="ztpay != 1">
        <div @click="orderDetails" class="btn">查看订单</div>
        <div @click="orderDetails" class="btn redbtn leftsp">重新支付</div>
      </div>
    </div>
    <act-coupon></act-coupon>
    <!-- 会议信息模块 -->
    <div
      class="meeting-section meeting-card pt11 over-h"
      :style="{ backgroundImage: 'url(' + mettingData.mettingBgImg + ')' }"
      v-if="payResult == 'success' && mettingData.mettingId"
    >
      <div class="meeting-title f15 fw-b color-29 lh17 pl12 pr12">{{ mettingData.title }}</div>
      <div
        class="meeting-info radius-8px pt50 pr22"
        style="background-image: url('/static/images/meeting/20260226/giftbg.png')"
      >
        <div class="meeting-info-label f12 mb4 color-29">
          会议地址：{{ mettingData.mettingAddress }}
        </div>
        <div class="meeting-info-label f12 mb4 color-29">会议时间：{{ mettingData.time }}</div>
        <div class="meeting-info-label f12 mb10 color-29">
          会议联系人：{{ mettingData.meetingContact }} {{ mettingData.contacMobile }}
        </div>

        <van-button
          type="danger"
          block
          round
          size="small"
          color="linear-gradient( 90deg, #FC0324 0%, #FF144F 100%)"
          class="meeting-btn f12 ml15"
          @click="openMeetingSignup"
        >
          参与报名
        </van-button>
      </div>
    </div>
    <div
      class="checkgroup"
      v-if="checkGroup != null && checkGroup.is_tips == 1"
      @click="goGroup(1)"
    >
      <img src="/static/images/checkgroup.png" />
    </div>
    <div
      class="checkgroup"
      v-if="checkGroup != null && checkGroup.showstatus == 1 && checkGroup.bill_url"
      @click="goGroup(2)"
    >
      <img src="/static/images/anniversary.jpg" />
    </div>
    <!--  <div class="checkgroup" v-if="payResult == 'success' && drawprizetips != null && drawprizetips.showtips == 2" @click="goGift()">-->
    <!--    <img src="../../assets/images/888no.png">-->
    <!--  </div>-->
    <!--  <div class="checkgroup" v-if="payResult == 'success' && drawprizetips != null && drawprizetips.showtips == 1" @click="goGift()">-->
    <!--    <img src="../../assets/images/888yes.png">-->
    <!--  </div>-->
    <div class="good_info" v-if="productlist && productlist.length > 0" style="margin-top: 0">
      <div class="tit">
        {{
          yl == 1 && lb != 1 && ann != 1 && anncc != 1
            ? '各类肌肤，专业精选'
            : '买此商品的用户还买了'
        }}
      </div>
      <div class="pro_related_list">
        <product-item
          v-for="(item, index) in productlist"
          :prolistItem="item"
          :key="index"
          :markPointData="{ scenepoint: 'PAYDETAIL' }"
        ></product-item>
      </div>
    </div>

    <van-overlay
      :show="drawprizetips && drawprizetips.showtips != 0"
      z-index="99999"
      v-if="drawprizetips && drawprizetips.showtips != 0"
    >
      <div class="wrapper">
        <div @click.stop class="block">
          <div>
            <img :src="drawprizetips.pop_img_url" @click="goGift()" />
          </div>
          <van-icon @click="closeAct" name="close" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="redPackageStatus" z-index="99999" v-if="redPackageStatus == 1">
      <div class="wrapper">
        <div @click.stop class="block">
          <div>
            <img src="../../assets/images/redPackageBg.png" @click="showRedPackage()" />
          </div>
          <van-icon @click="closeAct" name="close" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="ylitemtips.status" z-index="99999" v-if="ylitemtips.status">
      <div class="wrapper">
        <div @click.stop class="block">
          <div>
            <img :src="ylitemtips.pop_img_url" @click="goGuide()" />
          </div>
          <van-icon @click="closeAct" name="close" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showcoupon0326" v-if="showcoupon0326">
      <div class="wrapper">
        <div class="block">
          <div>
            <img :src="specialPopJSON.popads.pop_img_url" @click="goEwm(specialPopJSON.popads)" />
          </div>
          <van-icon @click="showcoupon0326 = false" name="close" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="newUser.show" v-if="newUser.show && newUser.pop_img_url" z-index="99999">
      <div class="wrapper">
        <div @click.stop class="block">
          <div><img :src="newUser.pop_img_url" @click="goQrcode()" /></div>
          <van-icon @click="closeAct" name="close" />
        </div>
      </div>
    </van-overlay>
    <van-overlay
      :show="friend_qrcode_pop.is_pop"
      v-if="friend_qrcode_pop.is_pop && friend_qrcode_pop.pop_img_url"
      z-index="99999"
    >
      <div class="wrapper">
        <div @click.stop class="block friend_qrcode">
          <div><img :src="friend_qrcode_pop.pop_img_url" /></div>
          <van-icon @click="friend_qrcode_pop.is_pop = 0" name="close" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="getSubscribeShow" v-if="getSubscribeShow" z-index="2002">
      <div class="wrapper">
        <div class="block">
          <img src="/static/images/gzhqrcode.png?v=1" />
          <van-icon @click="getSubscribeShow = false" name="close" />
        </div>
      </div>
    </van-overlay>
    <!----------20210920引流活动入口弹窗---------->
    <van-overlay :show="raffleshow" v-if="raffleshow" z-index="2002">
      <div class="wrapper">
        <div class="block">
          <img :src="raffleqrcode ? raffleqrcode : rafflepopup.pop_img_url" @click="gorafflelink" />
          <van-icon @click="closeraffle" name="close" />
        </div>
      </div>
    </van-overlay>
    <!----------统一弹窗样式---------->
    <van-overlay :show="show" v-if="show" z-index="2002">
      <div class="wrapper">
        <div class="block">
          <div style="position: relative">
            <img :src="popup.pop_img_url" @click="golink" />
            <div
              :path="popup.url + (popup.url.indexOf('?') >= 0 ? '&' : '?') + 'sorce=13'"
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="isWx && (popup.type == 4 || popup.type == 5)"
            ></div>
          </div>
          <van-icon @click="show = false" name="close" />
        </div>
      </div>
    </van-overlay>

    <!--2025-9-5 新增盲盒弹窗-->
    <blind-box-pop
      v-if="Object.keys(blindBox_pop).length > 0"
      ref="blindBoxPop"
      @resultHandle="orderDetails"
      :result="blindBox_pop"
    />

    <!-- 会议报名弹窗 -->
    <!-- 确认报名信息弹窗 -->
    <van-dialog
      v-model="meetingSignup.showPopup"
      title="确认报名信息"
      show-cancel-button
      cancel-button-color="#fc0324"
      cancel-button-text="修改信息"
      confirm-button-text="确认报名"
      :before-close="(action, done) => done(false)"
      @cancel="showEditPopupHandle"
      @confirm="submitSignup"
      class="w-87 collect_button_alert"
    >
      <div class="meeting-signup-info pl20 pb22">
        <div class="flex ai-c mb15">
          <span class="color-4 f14 flex-s">姓名：</span>
          <span>{{ meetingSignup.name || mettingData.receiverName }}</span>
        </div>
        <div class="flex ai-c">
          <span class="color-4 f14 flex-s">电话：</span>
          <span>{{ meetingSignup.phone || mettingData.receiverphone }}</span>
        </div>
      </div>
    </van-dialog>

    <!-- 编辑报名信息弹窗 -->
    <van-dialog
      v-model="meetingSignup.showEditPopup"
      title="确认报名信息"
      show-cancel-button
      cancel-button-color="#fc0324"
      cancel-button-text="取消"
      confirm-button-text="确认报名"
      :before-close="(action, done) => done(false)"
      @cancel="meetingSignup.showEditPopup = false"
      @confirm="submitSignup"
      class="w-87 collect_button_alert"
    >
      <div class="meeting-signup-edit">
        <div class="flex ai-c jc-c mb8">
          <span class="f14 color-2 flex-s title">姓名：</span>
          <input
            type="text"
            class="f14 pl10 pr10"
            v-model="meetingSignup.name"
            maxlength="15"
            placeholder="请输入姓名"
          />
        </div>
        <div class="flex ai-c jc-c">
          <span class="f14 color-2 flex-s title">电话：</span>
          <input
            type="tel"
            class="f14 pl10 pr10"
            v-model="meetingSignup.phone"
            placeholder="请输入电话"
            maxlength="11"
          />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import productItem from '../common/productItem'
import {
  fenxiang,
  isWeixin,
  downloadpath,
  popType,
  goXcxCreateBtnFn
} from '../../assets/common/js/config'
import actCoupon from '../../components/common/coupon'
import '../../../static/wx/css/mobilePop.css'
import blindBoxPop from '../common/blindBoxPop.vue'
import Vue from 'vue'

Vue.config.ignoredElements = ['wx-open-launch-weapp']
export default {
  name: 'payResult',
  data() {
    return {
      showcoupon0326: false,
      id: this.$route.query.id ? this.$route.query.id : '',
      yl: this.$route.query.yl || 0,
      ann: this.$route.query.ann || 0,
      lb: this.$route.query.lb || 0,
      ztpay: this.$route.query.ztpay || 0,
      time: 0,
      money: this.$route.query.money ? this.$route.query.money : 0,
      order: null,
      format: 'DD 天 HH 时 mm 分 ss 秒',
      productlist: [],
      payResult: '-1',
      checkGroup: null,
      exchangebuytips: '', // 加购提示
      exchangebuy_adtitle: '', // 加购提示
      changebuytips: '',
      changebuy_adtitle: '',
      integralcount: 0,
      integralType: '-1',
      getintegral: 0,
      orderInfo: null, // 订单详情
      anncc: this.$route.query.anncc || 0,
      drawprizetips: null,
      presell: null,
      presell_adtitle: '',
      couponstips: null,
      isPopupSort: 0,
      redPackageStatus: null,
      redenv: {},
      drawprizetipsShow: null,
      jumpUrl: '', // 红包封面跳转链接
      isdeposit: null, // 预售付定金
      ylitemtips: {
        // 引流弹窗
        status: false,
        url: null
      },
      canbuyactItems: null,
      specialPopJSON: {
        ispop: 0, // 是否弹出
        poptimes: 0, // 弹出次数
        popads: {
          pop_img_url: '',
          pop_ad_type: 1,
          pop_ad_target: ''
        }
      },
      newUser: {
        // 新人有礼专区商品购买弹窗
        status: 0, // 0/1 弹窗是否显示，默认不显示
        url: '', // 跳转链接
        show: false,
        pop_img_url: ''
      },
      friend_qrcode_pop: {
        is_pop: 0,
        pop_img_url: ''
      },
      getSubscribeShow: false,
      raffleshow: false, // 20210920引流活动
      rafflepopup: {
        // 20210920引流活动
        is_pop: 0,
        pop_img_url: '',
        qrcode_img_url: ''
      },
      raffleqrcode: '',
      show: false, // 支付结果弹窗统一变量
      popup: {
        // 支付结果弹窗统一obj
        is_pop: 0,
        pop_img_url: 0,
        url: '',
        type: '',
        itembaseid: '',
        popup_type: '',
        ad_title: ''
      },
      isWx: isWeixin() ? 1 : 0,
      blindBox_pop: {},
      mettingData: {},
      // 会议报名相关
      meetingSignup: {
        name: '',
        phone: '',
        showPopup: false,
        showEditPopup: false,
        showSuccessPopup: false,
        showFailPopup: false,
        hasOtherMeeting: false,
        isSubmitting: false // 防止接口并发调用
      }
    }
  },
  components: {
    productItem,
    actCoupon,
    blindBoxPop
  },
  created() {
    this.integralType = this.$route.query.integralType || '-1'
    this.integralcount = this.$route.query.integralcount
    this.isdeposit = this.$route.query.isdeposit || ''
  },
  mounted() {
    if (isWeixin()) {
      fenxiang({ path: 'payresult' })
    }
    if (this.$route.query.payresult) {
      this.payResult = decodeURIComponent(this.$route.query.payresult)
    }
    if (this.ztpay != 1) {
      this.getOrderInfo()
    }
    this.getData()
  },
  computed: {
    hideIndexFloat() {
      return this.$route.query.isShowIndex == 0 || this.$route.query.isShowIndex === '0'
    }
  },
  methods: {
    closeAct: function () {
      this.redPackageStatus = 0
      this.drawprizetips != null ? (this.drawprizetips.showtips = 0) : (this.drawprizetips = null)
      this.ylitemtips.status = false
      this.newUser.show = false
    },
    getData() {
      var orderUrl = this.$ajax.getOrderById_URL + '?id=' + this.id
      var checkUrl = this.$ajax.checkOrderMoney_URL + '?money=' + this.money + '&oid=' + this.id
      var url = this.$ajax.getRecommendByPaymentPage_URL
      if (
        this.$route.query.yl == 1 &&
        this.$route.query.lb != 1 &&
        this.$route.query.ann != 1 &&
        this.$route.query.anncc != 1
      ) {
        var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
        if (shopConfirmResult.itemidArr) {
          url =
            this.$ajax.getRecommendByPaymentPage_URL +
            '?item_base_id=' +
            shopConfirmResult.itemidArr.join()
        }
      }
      var that = this
      if (that.$route.query.payresult == 'failure' && that.ztpay != 1) {
        that.$customRequestAjax(orderUrl).then((res) => {
          if (res.data.code === 200) {
            that.order = res.data
            var nowTime = new Date().getTime()
            var futureTime = null
            if (that.order.orderstatus == 1) {
              // 待付款
              if (
                that.order.ordertime != '' &&
                that.order.ordertime != undefined &&
                that.order.close_time != 0 &&
                that.order.close_time != '' &&
                that.order.close_time != undefined
              ) {
                futureTime =
                  that.parserDate(that.order.ordertime).getTime() +
                  parseInt(that.order.close_time) * 1000 * 60
                that.time = futureTime - nowTime
                if (that.time < 86400000) {
                  that.format = 'HH 时 mm 分 ss 秒'
                }
                if (that.time < 3600000) {
                  that.format = 'mm 分 ss 秒'
                }
                if (that.time < 60000) {
                  that.format = 'ss 秒'
                }
              }
            }
          }
        })
      } else if (that.ztpay != 1) {
        that.$customRequestAjax(checkUrl).then((res) => {
          if (res.data.code == 200) {
            // that.$identity({
            //   callback: function (res) {
            //     if (res.data.code == 200) {
            //       sessionStorage.setItem('is_woolparty', res.data.is_woolparty)
            //     }
            //   }
            // })
            that.getintegral = res.data.data.getintegral
            that.checkGroup = res.data.data
            that.couponstips = res.data.data.couponstips ? res.data.data.couponstips : null
            that.presell = res.data.data.presell ? res.data.data.presell : null
            that.presell_adtitle = res.data.data.presell_adtitle || ''
            that.exchangebuytips = res.data.data.exchangebuytips || ''
            that.exchangebuy_adtitle = res.data.data.exchangebuy_adtitle || ''
            that.changebuytips = res.data.data.changebuytips || ''
            that.changebuy_adtitle = res.data.data.changebuy_adtitle || ''
            that.canbuyactItems = res.data.data.canbuyactItems ? res.data.data.canbuyactItems : null
            that.newUser = Object.assign(that.newUser, res.data.data.newUser)
            // 判断当前时间是否在2025-5-13 00:00:00至2025-05-27 23:59:59之间
            var currentTime = new Date().getTime()
            var startTime = new Date('2025/5/13 00:00:00').getTime() // 注意月份从0开始，4代表5月
            var endTime = new Date('2025/5/20 23:59:59').getTime()
            const inActTime = currentTime >= startTime && currentTime <= endTime
            that.blindBox_pop = {}
            if (!that.hideIndexFloat) {
              if (Object.keys(res.data.data.blindBoxPop).length > 0) {
                that.blindBox_pop = res.data.data.blindBoxPop
                that.$nextTick(() => {
                  that.$refs.blindBoxPop.open()
                })
              } else if (
                inActTime &&
                res.data.data.payitempopu &&
                res.data.data.payitempopu.is_pop == 1
              ) {
                // 特殊商品引流弹窗
                that.show = true
                that.popup = Object.assign(that.popup, res.data.data.payitempopu)
                that.popup.popup_type = 'payitempopu'
                setTimeout(function () {
                  goXcxCreateBtnFn(that)
                }, 50)
              } else if (
                res.data.data.anniversaryCoupon &&
                res.data.data.anniversaryCoupon.is_pop == 1
              ) {
                // 买商品送券/引流赠券（购买 全部商品||指定商品 发券）
                that.show = true
                that.popup = Object.assign(that.popup, res.data.data.anniversaryCoupon)
                that.popup.popup_type = 'anniversaryCoupon'
                setTimeout(function () {
                  goXcxCreateBtnFn(that)
                }, 50)
              } else if (
                res.data.data.fullMoneyPrizePop &&
                res.data.data.fullMoneyPrizePop.is_pop == 1
              ) {
                // 周年庆累计下单得好礼活动入口弹窗
                that.show = true
                that.popup = {
                  is_pop: res.data.data.fullMoneyPrizePop.is_pop,
                  pop_img_url: res.data.data.fullMoneyPrizePop.pop_img,
                  url: res.data.data.fullMoneyPrizePop.jump_url,
                  popup_type: 'anniversarypopu',
                  ad_title: '周年庆累计下单得好礼活动'
                }
              } else if (
                res.data.data.isup50vipsucc == 1 ||
                res.data.data.isBeautyUpVipSuccess == 1
              ) {
                // 是否升级成功 因为您购买了商品名称，恭喜您升级成为50VIP，请下载APP，使用下单时输入手机号号登录，初始密码为手机号后6位
                that.$dialog
                  .alert({
                    message: res.data.msg,
                    className: 'upvip_button_alert percen_button_alert',
                    confirmButtonColor: '#FFFCFC',
                    confirmButtonText: '立即下载',
                    closeOnPopstate: false
                  })
                  .then(() => {
                    that.$clickburiedPoint({
                      data: {
                        buttonCode: 'payprop',
                        buttontext:
                          res.data.data.isup50vip_adtitle || res.data.data.isBeautyUpVip_adtitle
                      },
                      callback: () => {
                        window.location = downloadpath
                      }
                    })
                  })
                  .catch(function () {})
              } else if (res.data.data.logisticstips == 1 && isWeixin()) {
                // 关注公众号弹窗
                that.getSubscribeShow = true
              } else if (res.data.data.drawprizetips && res.data.data.drawprizetips.showtips == 1) {
                // 满额抽奖 888抽奖
                that.drawprizetips = res.data.data.drawprizetips
              } else if (res.data.data.newUser && res.data.data.newUser.status == 1) {
                // 新人有礼购买后引流弹窗
                this.newUser.show = true
              } else if (
                res.data.data.specialpop.ispop &&
                res.data.data.specialpop.ispop == 1 &&
                parseInt(
                  localStorage.getItem('specialPopResultpopFlag')
                    ? localStorage.getItem('specialPopResultpopFlag')
                    : 0
                ) <=
                  parseInt(res.data.data.specialpop.poptimes ? res.data.data.specialpop.poptimes : 0)
              ) {
                // 私域二维码 特殊店铺引流弹窗
                sessionStorage.removeItem('specialPopResultoncePopupFlag')
                sessionStorage.removeItem('specialPopResultpopFlagBool')
                popType(
                  parseInt(res.data.data.specialpop.poptimes),
                  res.data.data.specialpop,
                  'specialPopResult',
                  () => {
                    this.specialPopJSON.popads = Object.assign(
                      {},
                      this.specialPopJSON.popads,
                      res.data.data.specialpop.popads
                    )
                    this.showcoupon0326 = true
                  }
                )
                // 私域弹窗 每天首次弹出
              } else if (res.data.data.emplpopu && res.data.data.emplpopu.is_pop == 1) {
                // 总监社群引流弹框
                that.friend_qrcode_pop = Object.assign(
                  {},
                  that.friend_qrcode_pop,
                  res.data.data.emplpopu
                )
              } else if (
                !inActTime &&
                res.data.data.payitempopu &&
                res.data.data.payitempopu.is_pop == 1
              ) {
                // 特殊商品引流弹窗
                that.show = true
                that.popup = Object.assign(that.popup, res.data.data.payitempopu)
                that.popup.popup_type = 'payitempopu'
                setTimeout(function () {
                  goXcxCreateBtnFn(that)
                }, 50)
              } else if (res.data.data.qrcode && res.data.data.qrcode.is_pop == 1) {
                // 二维码弹窗
                that.friend_qrcode_pop = Object.assign(
                  {},
                  that.friend_qrcode_pop,
                  res.data.data.qrcode
                )
              } else if (
                res.data.data.friend_qrcode_pop &&
                res.data.data.friend_qrcode_pop.is_pop == 1
              ) {
                // 朋友圈二维码弹窗
                that.friend_qrcode_pop = Object.assign(
                  {},
                  that.friend_qrcode_pop,
                  res.data.data.friend_qrcode_pop
                )
              } else if (res.data.data.raffle && res.data.data.raffle.is_pop == 1) {
                // 2021.9.20 抽奖弹窗
                that.raffleshow = true
                that.rafflepopup = Object.assign(that.rafflepopup, res.data.data.raffle)
                that.popup.popup_type = 'rafflepopup'
                setTimeout(function () {
                  goXcxCreateBtnFn(that)
                }, 50)
              } else if (res.data.data.ylitemtips && res.data.data.ylitemtips.status) {
                // 38引流商品支付完成弹窗
                that.ylitemtips = {
                  status: !!(res.data.data.ylitemtips && res.data.data.ylitemtips.status),
                  url: res.data.data.ylitemtips ? res.data.data.ylitemtips.url : null,
                  pop_img_url: res.data.data.ylitemtips ? res.data.data.ylitemtips.pop_img_url : ''
                }
              } else if (that.canbuyactItems && that.canbuyactItems.isshow == 1) {
                // 加/换购提示弹窗
                that.$dialog
                  .confirm({
                    message: that.canbuyactItems.tips,
                    className: 'collect_button_alert',
                    cancelButtonColor: '#FC0324',
                    confirmButtonColor: '#FFFCFC',
                    confirmButtonText: '去看看',
                    cancelButtonText: '我知道了',
                    closeOnPopstate: true
                  })
                  .then(function () {
                    // on confirm
                    that.$clickburiedPoint({
                      data: {
                        buttonCode: 'payprop',
                        buttontext: that.canbuyactItems.ad_title
                      },
                      callback: () => {
                        window.location.href = that.canbuyactItems.url
                      }
                    })
                  })
                  .catch(function () {
                    // on cancel
                    that.isPopupSort = 1
                  })
              } else if (res.data.data.redenvtips && res.data.data.redenvtips.status == 1) {
                // 红包封面信息
                that.getJumpUrl(res.data.data.redenvtips)
              } else if (that.couponstips != null && that.couponstips.showtips == 1) {
                // 送1000的券
                that.$dialog
                  .confirm({
                    message: '恭喜您，获得30元现金券，可去“我的——卡券”中查看',
                    className: 'collect_button_alert',
                    cancelButtonColor: '#FC0324',
                    confirmButtonColor: '#FFFCFC',
                    confirmButtonText: '去使用',
                    cancelButtonText: '知道了',
                    closeOnPopstate: true
                  })
                  .then(function () {
                    // on confirm
                    that.$clickburiedPoint({
                      data: {
                        buttonCode: 'payprop',
                        buttontext: that.couponstips.ad_title
                      },
                      callback: () => {
                        that.$router.replace({ path: '/cashcoupon' })
                      }
                    })
                  })
                  .catch(function () {
                    // on cancel
                    that.isPopupSort = 1
                  })
              } else if (that.exchangebuytips) {
                // 加购提示信息
                that.$dialog
                  .confirm({
                    message: that.exchangebuytips,
                    className: 'collect_button_alert',
                    cancelButtonColor: '#FC0324',
                    confirmButtonColor: '#FFFCFC',
                    confirmButtonText: '去购买',
                    cancelButtonText: '暂不',
                    closeOnPopstate: true
                  })
                  .then(function () {
                    // on confirm
                    that.$clickburiedPoint({
                      data: {
                        buttonCode: 'payprop',
                        buttontext: that.exchangebuy_adtitle
                      },
                      callback: () => {
                        var shopConfirmResult = localStorage.getItem('shopConfirmResult')
                          ? JSON.parse(localStorage.getItem('shopConfirmResult'))
                          : null
                        var skuids = shopConfirmResult.skuidArr.join()
                        localStorage.removeItem('shopConfirmResult')
                        that.$router.replace({
                          path: '/allProductList',
                          query: {
                            skuids: skuids,
                            type: 'orderInfo',
                            oid: that.id
                          }
                        })
                      }
                    })
                  })
                  .catch(function () {
                    // on cancel
                    that.isPopupSort = 1
                  })
              } else if (that.changebuytips) {
                // 换购提示信息
                that.$dialog
                  .confirm({
                    message: that.changebuytips,
                    className: 'collect_button_alert',
                    cancelButtonColor: '#FC0324',
                    confirmButtonColor: '#FFFCFC',
                    confirmButtonText: '去换购',
                    cancelButtonText: '取消',
                    closeOnPopstate: true
                  })
                  .then(function () {
                    // on confirm
                    that.$clickburiedPoint({
                      data: {
                        buttonCode: 'payprop',
                        buttontext: that.changebuy_adtitle
                      },
                      callback: () => {
                        var shopConfirmResult = localStorage.getItem('shopConfirmResult')
                          ? JSON.parse(localStorage.getItem('shopConfirmResult'))
                          : null
                        var skuids = shopConfirmResult.skuidArr.join()
                        localStorage.removeItem('shopConfirmResult')
                        that.$router.replace({
                          path: '/allProductList',
                          query: {
                            skuids: skuids,
                            type: 'orderInfo',
                            oid: that.id,
                            changebuystatus: 1
                          }
                        })
                      }
                    })
                  })
                  .catch(function () {
                    // on cancel
                    that.isPopupSort = 1
                  })
              } else if (that.presell != null && that.presell.length > 0) {
                this.$dialog
                  .alert({
                    message: that.presell.join('<br/>'),
                    className: 'percen_button_alert',
                    confirmButtonColor: '#FFFCFC',
                    confirmButtonText: '知道了',
                    closeOnPopstate: false
                  })
                  .then(function () {
                    // on confirm
                    that.$clickburiedPoint({
                      data: {
                        buttonCode: 'payprop',
                        buttontext: that.presell_adtitle
                      },
                      callback: () => {
                        that.orderDetails()
                      }
                    })
                  })
                  .catch(function () {
                    // on cancel
                    that.isPopupSort = 1
                  })
              }
            }
          }
        })
        that
          .$customRequestAjax(that.$ajax.getOfflineYLMeeting_URL + '?oid=' + that.id)
          .then((res) => {
            if (res.data.code == 200) {
              that.mettingData = res.data.mettingData || {}
            }
          })
      }
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.productlist = res.data.itemlist
        }
      })
    },
    // 获取订单信息
    getOrderInfo() {
      var url = this.$ajax.getOrderById_URL + '?id=' + this.id,
        that = this

      if (this.isdeposit) {
        return
      }

      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.orderInfo = res.data
          that.dataCollection('productPaySuccess')
          that.dataCollection('orderPaySuccess')
        }
      })
    },
    dataCollection(type) {
      let params
      if (type == 'orderPaySuccess') {
        // 订单提交成功&订单支付成功
        params = {
          orderId_var: this.orderInfo.id, // 订单id
          actualPayment_var: this.orderInfo.pay_money, // 实际支付金额
          payMethod_var: this.orderInfo.paymethod, // 支付方式
          ifCouponUsed_var: this.orderInfo.coupon_money ? '是' : '否', // 是否使用现金券
          couponType_var: '', // 现金券类型
          couponName_var: '', // 现金券名称
          orderAddress_var: this.orderInfo.getteraddress // 订单收货城市
        }
        gio('track', type, params)
      } else {
        let list = this.orderInfo.itemlist
        for (let i = 0; i < list.length; i++) {
          params = {
            orderId_var: this.orderInfo.id, // 订单id
            productId_var: list[i].itembaseid, // 商品id
            productName_var: list[i].name, // 商品名称
            firstCat_var: '', // 商品一级分类
            productType_var: '', // 商品品类
            productFormat_var: list[i].itemid, // 商品规格
            buyQuantity_var: list[i].nums, // 购买数量
            payAmount_var: this.orderInfo.pay_money // 支付金额
          }
          gio('track', type, params)
        }
      }
    },
    // 获取跳转小程序链接
    getJumpUrl(info) {
      if (isWeixin()) {
        this.jumpUrl = info.url
        this.redPackageStatus = 1
      } else {
        let that = this,
          url = that.$ajax.getMyWapRedenv_URL
        that.$customRequestAjax(url).then((res) => {
          if (res.data.code === 200) {
            that.jumpUrl = res.data.redenv.url || ''
            that.redenv = res.data.redenv
            that.redPackageStatus = 1
          }
        })
      }
    },
    // 红包封面弹窗
    showRedPackage() {
      if (!this.jumpUrl) {
        return
      }
      this.$clickburiedPoint({
        data: {
          buttonCode: 'payprop',
          buttontext: this.redenv.ad_title
        },
        callback: () => {
          location.href = this.jumpUrl
        }
      })
    },
    // 引流商品引导页
    goGuide() {
      if (this.ylitemtips.url) {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'payprop',
            buttontext: this.ylitemtips.ad_title
          },
          callback: () => {
            window.location.href = this.ylitemtips.url
          }
        })
      }
    },
    // 新人有礼专区商品购买弹窗-跳至特定二维码页
    goQrcode() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'payprop',
          buttontext: this.newUser.ad_title
        },
        callback: () => {
          window.location.href = this.newUser.url
        }
      })
    },
    golink: function () {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'payprop',
          buttontext: this.popup.ad_title
        },
        callback: () => {
          if (this.popup.url && this.popup.type != 4 && this.popup.type != 5) {
            window.location = this.popup.url
            return
          } else if (this.popup.type == 0 && this.popup.itembaseid) {
            window.location = '/productdetail?itemid=' + this.popup.itembaseid
            return
          } else if (this.popup.type == 4) {
            // 直播列表
            if (isWeixin()) {
            } else {
              this.$toast('请前往微信搜索小程序「创客云商可丽金官方」')
            }
            return
          } else if (this.popup.type == 5) {
            // 直播间
            if (isWeixin()) {
            } else {
              this.$toast('请前往微信搜索小程序「创客云商可丽金官方」')
            }
            return
          } else if (this.popup.popup_type == 'payitempopu') {
            return
          }
          window.location.href = '/cashcoupon'
        }
      })
    },
    gorafflelink: function () {
      if (this.raffleqrcode != '') {
        return
      }
      if (this.rafflepopup.url) {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'payprop',
            buttontext: this.rafflepopup.ad_title
          },
          callback: () => {
            this.$buriedPoint({
              behavior: '100',
              userfrom: 5
            })
            window.location.href = this.rafflepopup.url
          }
        })
      }
    },
    closeraffle: function () {
      if (this.raffleqrcode == '') {
        this.$buriedPoint({ behavior: '112' })
        if (this.rafflepopup.qrcode_img_url) {
          this.$buriedPoint({ behavior: '113' })
          this.raffleqrcode = this.rafflepopup.qrcode_img_url
        } else {
          this.raffleshow = false
        }
      } else {
        this.raffleshow = false
      }
    },
    goGroup: function (type) {
      if (type == 1) {
        window.location.href = this.checkGroup.url
      } else if (type == 2) {
        if (this.checkGroup.bill_url.indexOf('anniversary-bill-big-swiper')) {
          sessionStorage.removeItem('anniversary-bill-pop-show')
        }
        window.location.href = this.checkGroup.bill_url
      }
    },
    goGift: function () {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'payprop',
          buttontext: this.drawprizetips.ad_title
        },
        callback: () => {
          window.location.href = this.drawprizetips.url
        }
      })
    },
    parserDate: function (date) {
      var t = Date.parse(date.replace(/-/g, '/'))
      if (!isNaN(t)) {
        return new Date(Date.parse(date.replace(/-/g, '/')))
      } else {
        return new Date()
      }
    },
    closeOrder() {
      if (this.order != '' && this.order != null && this.order != undefined) {
        this.orderDetails()
      }
    },
    groupQuery(extra) {
      var query = extra || {}
      if (this.$route.query.actgroupid) {
        query.actgroupid = this.$route.query.actgroupid
      }
      if (this.$route.query.isShowIndex == 0 || this.$route.query.isShowIndex == 1) {
        query.isShowIndex = this.$route.query.isShowIndex
      }
      if (this.$route.query.newpersonhide) {
        query.newpersonhide = this.$route.query.newpersonhide
      }
      return query
    },
    orderDetails() {
      if (this.isdeposit == 1) {
        this.$store.commit('ORDERLIST_NAVID', 0)
        this.$router.push({
          path: '/myorder',
          query: this.groupQuery()
        })
      } else {
        this.$router.replace({
          path: '/orderdetails',
          query: this.groupQuery({
            router: 'replace',
            id: this.id
          })
        })
      }
    },
    other(type) {
      if (type == 1) {
        window.location = '/static/wx/html/anniversary-bill-big-swiper.html'
      } else {
        this.$router.replace({
          path: '/classification',
          query: {
            router: 'replace',
            type: 'inside'
          }
        })
      }
    },
    goEwm(item) {
      // let src = this._specialPopFn(item)
      if (item.pop_ad_target) {
        this.showcoupon0326 = false
        this.$clickburiedPoint({
          data: {
            buttonCode: 'payprop',
            buttontext: item.ad_title
          },
          callback: () => {
            window.location.replace(item.pop_ad_target)
          }
        })
      }
    },
    showEditPopupHandle() {
      this.meetingSignup.showEditPopup = true
      this.meetingSignup.showPopup = false
    },
    submitSignup() {
      // 防止接口并发调用
      if (this.meetingSignup.isSubmitting) {
        return
      }

      if (this.meetingSignup.showEditPopup) {
        // 格式校验：姓名非空，手机号非空且格式正确
        if (!this.meetingSignup.name) {
          return this.$toast('姓名不能为空')
        }
        if (!this.meetingSignup.phone) {
          return this.$toast('手机号不能为空')
        }
        const phoneReg = /^1[3-9]\d{9}$/
        if (!phoneReg.test(this.meetingSignup.phone)) {
          return this.$toast('请输入正确的手机号')
        }
      }

      // 提交报名接口
      const params = {
        mettingId: this.mettingData.mettingId,
        name: this.meetingSignup.name || this.mettingData.receiverName,
        phone: this.meetingSignup.phone || this.mettingData.receiverphone,
        oid: this.id
      }

      // 设置提交状态为true
      this.meetingSignup.isSubmitting = true

      // 这里应该是实际的接口调用
      this.$customRequestAjax
        .post(this.$ajax.addOfflineYLMeeting_URL, params)
        .then((res) => {
          if (res.data.code == 200) {
            this.meetingSignup.showEditPopup = false
            this.meetingSignup.showPopup = false
            if (res.data.data.status == 1) {
              this.meetingSignup.showPopup = false
              this.$dialog
                .alert({
                  title: '报名成功',
                  message: res.data.data.tips,
                  className: 'percen_button_alert w-87',
                  confirmButtonColor: '#FFFCFC',
                  confirmButtonText: '我知道了',
                  closeOnPopstate: false
                })
                .then(function () {
                  // 跳转到会议列表页面
                  window.location.href = '/static/wx/html/meeting/registrationlist.html'
                })
            } else if (res.data.data.status == 2) {
              this.meetingSignup.showPopup = false
              this.$dialog
                .confirm({
                  message: res.data.data.tips,
                  className: 'w-87 collect_button_alert',
                  cancelButtonColor: '#FC0324',
                  confirmButtonColor: '#FFFCFC',
                  confirmButtonText: '放弃报名',
                  cancelButtonText: '取消其他场会议',
                  closeOnPopstate: true
                })
                .then(() => {})
                .catch(() => {
                  // 点击取消其他场会议按钮，跳转到会议列表页面
                  window.location.href = '/static/wx/html/meeting/registrationlist.html'
                })
            } else if (res.data.data.status == 3) {
              this.meetingSignup.showPopup = false
              this.$dialog
                .alert({
                  message: res.data.data.tips,
                  className: 'w-87 percen_button_alert',
                  confirmButtonColor: '#FFFCFC',
                  confirmButtonText: '放弃报名',
                  closeOnPopstate: false
                })
                .then(function () {})
            }
          }
        })
        .finally(() => {
          // 无论接口调用成功还是失败，都将提交状态设置为false
          this.meetingSignup.isSubmitting = false
        })
    },
    openMeetingSignup() {
      this.meetingSignup = {
        ...this.meetingSignup,
        name: this.mettingData.receiverName,
        phone: this.mettingData.receiverphone
      }
      this.meetingSignup.showPopup = true
    }
    // _specialPopFn (item) {
    //   let str
    //   switch (String(item.pop_ad_type)) {
    //     case '1': // 跳转链接(关联活动)
    //       str = item.pop_ad_target
    //       break
    //     case '2': // 商品分类
    //       str = item.pop_ad_target
    //       break
    //     case '3': // 商品编号
    //       str = item.pop_ad_target
    //       break
    //     case '4': // 商品分组编号
    //       str = item.pop_ad_target
    //       break
    //     case '7': // 直播列表
    //       str = item.pop_ad_target
    //       break
    //     case '8': // 直播间
    //       str = item.pop_ad_target
    //       break
    //   }
    //   return str
    // },
  }
}
</script>

<style scoped lang="scss">
.container {
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .block {
      width: 80%;
      background-color: transparent;
      text-align: center;
      font-size: 0;
      position: static;
      &.friend_qrcode div {
        /*background: #fff;*/
        padding: 0.32rem;
        border-radius: 0.08rem;
      }
      img {
        width: 100%;
      }
    }
    .van-icon-close {
      margin-top: 0.4rem;
      font-size: 35px;
      color: #fff;
    }
  }
  .pay_info {
    background: #fff;
    padding-top: 0.24rem;
    .money {
      text-align: center;
      color: #333333;
      font-size: 0.37rem;
      padding-top: 0.22rem;
      font-weight: 600;
      span {
        font-size: 0.23rem;
      }
    }
    .label,
    .integralcount {
      text-align: center;
      font-size: 0.18rem;
      color: #999;
    }
    .label {
      color: #333;
    }
    .paystatetxt {
      font-size: 0.16rem;
      color: #333;
      text-align: center;
      margin-top: 0.05rem;
      &.yellow {
        color: #ffb346;
        font-size: 0.14rem;
      }
      &.bold {
        font-weight: bold;
      }
    }
    .all {
      .money {
        padding-top: 0.1rem;
      }
    }
    .only {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0.18rem;
      .integral {
        color: #c58b53;
        font-size: 0.38rem;
        font-weight: bold;
        margin-right: 0.08rem;
      }
      .label {
        font-size: 0.2rem;
        font-weight: bold;
      }
    }
    .more {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0.08rem;
      .integral {
        color: #c58b53;
        font-size: 0.16rem;
      }
      .label {
        margin-right: 0.08rem;
        font-size: 0.18rem;
      }
    }
    .btnlist {
      margin-top: 0.32rem;
      padding-bottom: 0.33rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        border-radius: 0.14rem;
        border: 0.005rem solid rgba(96, 96, 96, 1);
        padding: 0.05rem 0.11rem;
        font-size: 0.12rem;
        text-align: center;
        color: #262626;
      }
      .redbtn {
        background: #fc0324;
        color: #fff;
        border-color: #fc0324;
      }
      .leftsp {
        margin-left: 0.25rem;
      }
    }
  }
  .pay_fail_info {
    background: #fff;
    padding-top: 0.24rem;
    .paystatetxt {
      font-size: 0.24rem;
      line-height: 0.33rem;
      color: #333333;
      font-weight: 600;
      text-align: center;
    }
    .paydesc {
      text-align: center;
      font-size: 0.14rem;
      color: #6d6d6d;
      font-weight: 400;
      line-height: 0.17rem;
      margin-top: 0.07rem;
      span {
        .van-count-down {
          color: #fc0324;
        }
      }
    }
    .btnlist {
      margin-top: 0.32rem;
      padding-bottom: 0.33rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        border-radius: 0.14rem;
        border: 0.005rem solid rgba(96, 96, 96, 1);
        padding: 0.05rem 0.11rem;
        font-size: 0.12rem;
        text-align: center;
        color: #262626;
      }
      .redbtn {
        background: #fc0324;
        color: #fff;
        border-color: #fc0324;
      }
      .leftsp {
        margin-left: 0.25rem;
      }
    }
  }
  .checkgroup {
    padding: 0 0.11rem 0.1rem;
    img {
      width: 100%;
    }
  }
  .good_info {
    margin-top: 0.15rem;
    background: #fff;
    padding: 0.13rem 0;
    .tit {
      font-size: 0.18rem;
      line-height: 0.25rem;
      padding-left: 0.11rem;
      padding-right: 0.11rem;
      font-weight: 400;
    }
    .pro_related_list {
      margin-top: 0.05rem;
      padding: 0.15rem 0.11rem 0;
      background: #fff;
      overflow: hidden;
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      flex-wrap: wrap;
      -moz-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      -o-flex-wrap: wrap;
      .pro_item:nth-child(2n) {
        padding-left: 0.035rem;
      }
      .pro_item:nth-child(2n-1) {
        padding-right: 0.035rem;
      }
    }
  }
  /* 会议信息模块样式 */
  .meeting-section {
    width: 100%;
    background-size: 100% 100%;
    background-position: center;
    .meeting-info {
      width: 100%;
      min-height: 1.87rem;
      padding-left: 0.9rem;
      background-size: 100% 100%;
      background-position: center;
    }
    .meeting-btn {
      width: 1.68rem;
    }
  }
  .meeting-signup-edit .title::before {
    content: '*';
    color: #fc0324;
  }
  .meeting-signup-edit {
    input {
      height: 0.32rem;
      width: 2.23rem;
      border: 0.01rem solid #e6e6e6;
      border-radius: 0.06rem;
      &::placeholder {
        color: #b0b0b0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/payResult.vue